import React, { useState, useEffect } from 'react';
import './Banner.css';

const facts = [
  'Event-Flows contribute to over 70% of Phosphorus Losses in subsurface drainage fields.',
  'Base flow separation can improve water quality management in agricultural fields.',
  'Subsurface drainage systems can reduce surface runoff by up to 50%.',
  'Event flows often carry higher nutrient concentrations than base flows.',
  'Monitoring soil temperature helps optimize drainage system performance.',
  'Average water table depth impacts crop yield and nutrient leaching in subsurface drainage fields.',
  'Event delineation methods enhance precision in drainage analysis.',
  'Phosphorus loss is a major contributor to water body eutrophication.',
  'Subsurface drainage fields require regular maintenance to prevent clogging.',
  'Accurate flow delineation supports sustainable farming practices.',
  'The Lyne–Hollick recursive digital filter separates fast and slow flow components using a physically interpretable algorithm rather than subjective thresholds.',
  'The Baseflow Index (BFI) derived from the Lyne–Hollick filter quantifies the fraction of drainage attributed to groundwater-driven flow.',
  'Selecting the filter parameter using the elbow of the BFI–α curve improves robustness and avoids arbitrary parameter selection.',
  'Seasonal variability significantly affects optimal Lyne–Hollick filter parameters due to changes in soil moisture, freeze–thaw cycles, and hydraulic conductivity.',
  'A unique value weighted mean baseflow reduces bias from repeated low-flow values in skewed drainage datasets.',
  'Tile drainage systems can increase baseflow contributions by nearly threefold, fundamentally altering watershed hydrology.',
  'Event thresholds derived from seasonal percentiles provide a consistent and transferable method for event identification across sites.',
  'Combining percentile thresholds with a 20% rise condition ensures hydrologically meaningful event detection rather than noise-driven classification.',
  'Hourly data reveals more drainage events than daily data, highlighting the importance of temporal resolution in hydrologic analysis.',
  'Event-based flow separation removes subjectivity and enables reproducible hydrologic interpretation across datasets.',
  'Tile drainage increases hydrograph flashiness by approximately 20 to 30%, accelerating water and nutrient transport.',
  'Subsurface drainage redistributes water by reducing surface runoff while increasing rapid subsurface export pathways.',
  'More permeable soils exhibit higher event flow dominance compared to clay-rich soils due to faster hydraulic response.',
  'Event-based analysis enables precise quantification of nutrient export during critical hydrologic periods.',
  'Standardized event delineation frameworks enable cross-site comparison and improve long-term water management strategies.'

];

const Banner = () => {
  const [currentFactIndex, setCurrentFactIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFactIndex(() => Math.floor(Math.random() * facts.length));
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="banner">
      <span className="banner-text" key={currentFactIndex}>
        *** Did you know? {facts[currentFactIndex]} ***
      </span>
    </div>
  );
};

export default Banner;